// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nhl4","content":"styles_content__2qCAl","tableWrap":"styles_tableWrap__3tCVU"};